'use client'

import { useFeatureFlagsContext } from '../context/feature-flags-context'

/**
 * Hook to check if a specific feature flag is enabled for the current user.
 *
 * Usage:
 *   const isJobBoardEnabled = useFeatureFlag('job_board')
 */
export function useFeatureFlag(key: string): boolean {
  const { isFeatureEnabled } = useFeatureFlagsContext()
  return isFeatureEnabled(key)
}

/**
 * Hook to access the full feature flags context.
 *
 * Usage:
 *   const { flags, isFeatureEnabled, isLoading, refreshFlags } = useFeatureFlags()
 */
export function useFeatureFlags() {
  return useFeatureFlagsContext()
}
